<template>
  <div>
    <div class="text-center">
      <span>选择查看</span>
      <Select v-model="selected" class="mx-1" style="width: 100px;">
        <Option v-for="it in select" :key="it.id" :value="it.id" :label="it.label"></Option>
      </Select>
      <Button @click="getTableData" :loading="loading">
        <span v-t="{ path: 'common.lookingFor' }"></span>
      </Button>
    </div>
    <Modal width="350" v-model="modal" footer-hide draggable :mask="false">
      <p slot="header">帐户[{{meminfo.memname}}]资讯為</p>
      <div>
        <ul class="report-mlgp-meminfo">
          <li>
            <span class="report-mlgp-meminfo-li-title">分公司:</span>
            {{meminfo.l2name}}
          </li>
          <li>
            <span class="report-mlgp-meminfo-li-title">大股东:</span>
            {{meminfo.l3name}}
          </li>
          <li>
            <span class="report-mlgp-meminfo-li-title">股东:</span>
            {{meminfo.l4name}}
          </li>
          <li>
            <span class="report-mlgp-meminfo-li-title">总代理:</span>
            {{meminfo.l5name}}
          </li>
        </ul>
      </div>
    </Modal>
    <lida-table
      v-show="frist"
      :propscolumns="columns"
      :data="items"
      :sortStatus="false"
      :propsPageSize="50"
      align="right"
      :SpinLoading="loading"
    ></lida-table>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { markSates } from '@/plugins/utils/game-id-filter.js';
import reportCount from '@/mixins/report-count.js'
export default {
  name: "report-mlgp",
  mixins: [reportCount],
  data () {
    return {
      items: [],
      loading: false,
      select: [
        { label: '分公司', id: 2 },
        { label: '大股东', id: 3 },
        { label: '股东', id: 4 },
        { label: '总代理', id: 5 },
        { label: '代理', id: 6 },
      ],
      selected: 2,
      frist: false,
      modal: false,
      meminfo: {}
    }
  },
  computed: {
    ...mapGetters(['lidaTableCheck']),
    queryData () {
      return this.$route.query
    },
    columns () {
      const object = {
        indexNumber: {
          title: '序号',
          align: 'center',
          key: 'indexNumber',
          width: 40
        },
        username: {
          title: '帐号',
          align: 'center',
          key: 'username',
          totaltext: '总计',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.username !== '总计') {
              return h('a', {
                on: {
                  click: () => this.getmeminfo(params.row.lid)
                }
              },
                [
                  h('span', { class: { pc3: true } }, `[${params.row.username}]`),
                  h('span', { class: { pc2: true } }, params.row.memname)
                ])
            } else {
              return h('span', params.row.username)
            }
          },
        },
        cou: {
          title: '注数',
          align: 'center',
          key: 'cou',
          width: 50,
          total: true,
          render: (h, params) => h('span', this.$commaFormat(params.row.cou))
        },
        sumval: {
          title: '下注金额',
          align: 'center',
          key: 'sumval',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'sumval')
        },
        effval: {
          title: '有效额',
          align: 'center',
          key: 'effval',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 20,
          render: (h, params) => {
            const value = params.row.effval * -1
            return h('p', this.NegativeColor(value), this.toDecimal2(value))
          }
        },
        payds: {
          title: '会员佣金',
          align: 'center',
          key: 'payds',
          className: 'trigger-show ',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'payds')
        },
        pal: {
          title: '会员盈亏',
          align: 'center',
          key: 'pal',
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'pal')
        },
        lupps: {
          title: '分公司占成上缴',
          align: 'center',
          key: 'lupps',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'lupps')
        },
        l1total: {
          title: '分公司上缴%',
          align: 'center',
          key: 'l1total',
          render: (h, params) => {
            const l1total = this.items.reduce((acc, val) => acc += val.l1tl, 0)
            return !this.checkFooterText(params.row.username) ? h('p', `${params.row.l1tl > 0 ? ((params.row.l1tl / l1total) * 100).toFixed(2) : 0}%`) : null
          },
        },
        lupt: {
          title: '分公司上缴',
          align: 'center',
          key: 'lupt',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'lupt')
        },
        odddiffval1: {
          title: '分公司差价数',
          align: 'center',
          key: 'odddiffval1',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          minWidth: 30,
          render: (h, params) => this.renderColorAmount(h, params, 'odddiffval1')
        },
        l1tltotal: {
          title: '公司占成(%)',
          align: 'center',
          key: 'l2p',
          render: (h, params) => {
            const value = params.row.effval != 0 ? ((params.row.l1tl / params.row.effval) * 100).toFixed(2) : 0
            return !this.checkFooterText(params.row.username) ? h('span', `${value}%`) : null
          },
        },
        l1tl: {
          title: '公司占成',
          align: 'center',
          key: 'l1tl',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1tl')
        },
        kekka: {
          title: '公司占成盈亏',
          align: 'center',
          key: 'kekka',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'kekka')
        },
        l1pds: {
          title: '公司赚佣',
          align: 'center',
          key: 'l1pds',
          className: 'trigger-show',
          triggerShow: true,
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'l1pds')
        },
        Cbonus: {
          title: '公司补货奖金',
          align: 'center',
          key: 'Cbonus',
          total: true,
          render: (h, params) => h('p', params.row.Cbonus)
        },
        bupayds: {
          title: '公司补货佣金',
          align: 'center',
          key: 'bupayds',
          total: true,
          render: (h, params) => h('p', params.row.bupayds)
        },
        cpal: {
          title: '公司盈亏',
          align: 'center',
          key: 'cpal',
          total: true,
          render: (h, params) => this.renderColorAmount(h, params, 'cpal')
        },
      }
      if (!markSates.onlySix(this.queryData.gameid) || this.queryData.gameid == '99') {
        delete object.odddiffval1
      }
      return object
    },
    apiData () {
      const { gameid, iscal, stdate, endate, buid, odddtl, mark, username } = this.queryData
      const result = {
        url: 'report4mlgp',
        gameid,
        stdate,
        endate,
        buid: Number(buid),
        stid: Number(this.query.stid),
        mlevel: this.selected,
        iscal: Number(iscal),
        username
      }
      return result
    }
  },
  methods: {
    async getTableData () {
      this.loading = true
      this.frist = true
      try {
        const res = await this.$axios.generalLedger.assortLedgerReport(this.apiData)
        if ('status' in res && res.status === 0) return
        if (Array.isArray(res)) return this.items = [], this.loading = false
        const keys = Object.keys(res)
        this.items = res[keys].map(it => {
          it.bupayds = 0
          it.Cbonus = 0
          return it
        })
        this.loading = false
      } catch (error) {
        console.log(error);
        this.$Message.error("请勿改动网站资讯!");
        this.$router.push({ name: this.$route.matched[1].name })
        this.loading = false
      }
    },
    async getmeminfo (value) {
      try {
        const res = await this.$axios.generalLedger.getmeminfo(value)
        this.meminfo = res[0]
        this.modal = true

      } catch (error) {
        this.modal = false
      }
    }
  }
}
</script>
<style lang="scss" >
.report-mlgp-meminfo {
  list-style-type: none;
  &-li-title {
    width: 60px;
    display: inline-block;
  }
}
</style>